import React from 'react';
import Icon from '.';

const CustomFilterIcon = props => (
	<Icon viewBox="0 0 24 24" {...props}>
		<defs>
			<path d="M20 6l-7 7v6l-2 1v-7L4 6h16z" id="CustomFilterIcon_svg__a" />
		</defs>
		<g fill="currentColor" fillRule="evenodd">
			<mask id="CustomFilterIcon_svg__b" fill="#fff">
				<use xlinkHref="#CustomFilterIcon_svg__a" />
			</mask>
			<use xlinkHref="#CustomFilterIcon_svg__a" />
			<g mask="url(#CustomFilterIcon_svg__b)">
				<path d="M0 0h24v24H0z" />
			</g>
		</g>
	</Icon>
);

export default CustomFilterIcon;
